import React from 'react';
import { PromoPopup } from './PromoPopup';
import { usePromoPopup } from '../../hooks/usePromoPopup';
import { X, Tag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const PromoPopupWrapper: React.FC = () => {
    const { isOpen, handleClose, isSideTabOpen, hasWelcomeCoupon, handleSideTabClose } = usePromoPopup();
    const { t, i18n } = useTranslation('shop');
    const isRTL = i18n.language === 'ar';
    
    return (
        <>
            <PromoPopup isOpen={isOpen} onClose={handleClose} />
            
            {/* Unified Vertical Pill Tab — sticks to the side edge */}
            {isSideTabOpen && hasWelcomeCoupon && (
                <div
                    className={`fixed z-[60] top-1/2 -translate-y-1/2 flex items-center shadow-2xl transition-all duration-300 ${
                        isRTL ? 'left-0' : 'right-0'
                    }`}
                >
                    <div
                        className={`flex flex-col items-center gap-2 bg-gradient-to-b from-red-600 via-red-600 to-red-700 text-white py-3.5 px-2 shadow-xl border border-red-500/40 select-none ${
                            isRTL ? 'rounded-r-2xl' : 'rounded-l-2xl'
                        }`}
                    >
                        {/* Clickable Action Area: Vertical Text + Tag Icon */}
                        <Link
                            to="/auth/register"
                            onClick={handleSideTabClose}
                            className="flex flex-col items-center gap-2 hover:opacity-90 transition-opacity cursor-pointer group"
                        >
                            <span
                                style={{
                                    writingMode: 'vertical-rl',
                                    textOrientation: 'mixed',
                                }}
                                className="font-extrabold text-[11px] md:text-xs tracking-widest uppercase"
                            >
                                {t('promoTab.getDiscount', 'Get Discount')}
                            </span>
                            <Tag size={14} className="text-white fill-white/20 shrink-0 group-hover:scale-110 transition-transform" />
                        </Link>

                        {/* Divider Line */}
                        <div className="w-4 h-[1.5px] bg-white/40 shrink-0 my-0.5" />

                        {/* Close Button */}
                        <button
                            onClick={handleSideTabClose}
                            aria-label={t('promoTab.close', 'Close')}
                            className="p-1 hover:bg-white/20 active:bg-white/30 rounded-full transition-colors flex items-center justify-center shrink-0 cursor-pointer text-white"
                        >
                            <X size={13} strokeWidth={2.5} />
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
